import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-table-pagination',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './table-pagination.component.html'
})
export class TablePaginationComponent {

  @Input() tableData:any[];
  @Input() itemsPerPage = 20;

  @Output() filterData= new EventEmitter();

  itemsPerPageOptions = [5, 10, 15, 20, 50];
  allData: any[] = [];
  currentPage = 1;
  totalPages = 1;
  
  ngOnInit() {
    this.allData = this.getData();
     this.applyPagination();
  }


  ngOnChanges(changes: SimpleChanges): void {
     
  }
  getData(){
      return this.tableData ?? []
  }
  applyPagination() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.totalPages = Math.ceil(this.allData.length / this.itemsPerPage);
    let paginatedData = this.allData.slice(start, end);
    this.filterData.emit(paginatedData);
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.applyPagination();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.applyPagination();
    }
  }

  goToFirstPage() {
    this.currentPage = 1;
    this.applyPagination();
  }

  goToLastPage() {
    this.currentPage = this.totalPages;
    this.applyPagination();
  }


  onItemsPerPageChange() {
    this.currentPage = 1;
    this.applyPagination();
  }
}
